import { render, staticRenderFns } from "./SiparisExcel.vue?vue&type=template&id=05ab6cee&"
import script from "./SiparisExcel.vue?vue&type=script&lang=js&"
export * from "./SiparisExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports